import React from "react";
import { toastr } from "react-redux-toastr";
import { FormGroup, FormControl, FormLabel } from "react-bootstrap";
import { expensesService, expStatus } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import { withTranslation } from "react-i18next";
import MobileExpenseAnswerSummary from "components/Expenses/Mobile/MobileExpenseAnswerSummary";
import "components/Expenses/Expenses.scss";
import "./ExpenseAnswerModal.scss";

class ExpenseAnswerModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			submitted: false,
			errors: {},
			answer_comments: props.expense.answer_comments || "",
		};
	}

	handleSubmit = async (isApproved) => {
		this.setState({ isLoading: true });

		const { expense } = this.props;

		const updated = {
			id: expense.id,
			day: expense.day,
			value: expense.value,
			type_id: expense.type_id ?? expense.type?.id,
			provider_id: expense.provider_id ?? expense.provider?.id,
			comments: expense.comments,
			payer_comments: expense.payer_comments,
			answer_comments: this.state.answer_comments,
			status: isApproved ? expStatus.approved : expStatus.denied,
		};

		const response = await expensesService.update(updated);

		const { t } = this.props;
		if (response.ok) {
			this.setState({ isLoading: false }, () => {
				toastr.success(
					t("common.success"),
					isApproved ? t("expenses.expenseApproved") : t("expenses.expenseDenied")
				);
				this.props.getExpenses();
				this.props.handleClose();
			});
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	render() {
		const { answer_comments, isLoading, errors, submitted } = this.state;
		const { t, expense, summary, expenseTypes } = this.props;

		return (
			<div className="expense-answer-modal">
				<div className="modal-body">
					{summary ?? (
						<MobileExpenseAnswerSummary
							expense={expense}
							expenseTypes={expenseTypes}
						/>
					)}
					<FormGroup controlId="answer_comments" className="form-group">
						<FormLabel>{t("expenses.answerModal.comments")}</FormLabel>
						<FormControl
							as="textarea"
							value={answer_comments}
							onChange={(e) =>
								this.setState({ answer_comments: e.target.value })
							}
							placeholder={t("expenses.answerModal.placeholder")}
							isInvalid={submitted && !!errors.answer_comments}
							rows={3}
						/>
						<FormControl.Feedback type="invalid">
							{errors.answer_comments}
						</FormControl.Feedback>
					</FormGroup>
				</div>

				<div className="modal-footer expense-answer-modal__footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-secondary expense-answer-modal__btn-cancel"
					>
						{t("common.cancel")}
					</button>
					<button
						type="button"
						className="btn btn-danger expense-answer-modal__btn-deny"
						disabled={isLoading}
						onClick={() => this.handleSubmit(false)}
					>
						{t("preferences.deny")}
					</button>
					<SubmitButton
						className="expense-answer-modal__btn-approve"
						isLoading={isLoading}
						text={t("preferences.approve")}
						loadingText={t("common.saving")}
						onClick={() => this.handleSubmit(true)}
					/>
				</div>
			</div>
		);
	}
}

export default withTranslation()(ExpenseAnswerModal);
